import { useEffect, useState } from 'react';
import { default as breakpoints, breakpointKeys } from './breakpoints';
import getMediaQueryString from './getMediaQueryString';
/** use useBeakpoint in app to get the context value and avoid recalculating all this */
export const useMediaQueryCalc = () => {
    const [breakpoint, setBreakpoint] = useState();
    useEffect(() => {
        let mediaQueryList;
        const setValue = () => {
            // defalts to 's'
            const newValue = breakpointKeys.find((key) => window.matchMedia(`(min-width: ${breakpoints[key]}px)`).matches) || 's';
            setBreakpoint(newValue);
            const mediaQueryString = getMediaQueryString(newValue);
            try {
                mediaQueryList?.removeEventListener('change', setValue);
                mediaQueryList = window.matchMedia(mediaQueryString);
                mediaQueryList && mediaQueryList.addEventListener('change', setValue);
            }
            catch (error) {
                // Safari < v14
                mediaQueryList?.removeListener(setValue);
                mediaQueryList = window.matchMedia(mediaQueryString);
                mediaQueryList && mediaQueryList.addListener(setValue);
            }
        };
        setValue();
        return () => {
            try {
                mediaQueryList && mediaQueryList.removeListener(setValue);
            }
            catch (error) {
                // Safari < v14
                mediaQueryList && mediaQueryList.addListener(setValue);
            }
        };
    }, [breakpoint, setBreakpoint]);
    // we want to optimise for mobile
    return breakpoint || 's';
};
export default useMediaQueryCalc;
//# sourceMappingURL=useMediaQueryCalc.js.map